/**
 * @description 展示风格定义，渲染不同场景配置
 */

import { IString } from '../../../model';
import { IConfigField } from './config-field';
import { IValue } from './filter';
import { IRenderSceneExtension } from './render-scene';

// 动态字段展示的区域，在搜索区域和表格内容部分，UI 界面展示会不同
// 排期页面：搜索条件中的是否排期 和 body 里面的排期操作，两者配置字段是一个，但展示形式不同
// 我们暂时先设计两种展示区域，后续我估计这将会是一个不利于扩展的地方
export enum DynamicRenderStyleMode {
  'filter' = 'filter',
  'tableBody' = 'tableBody',
}

// 组件布局扩展
export interface IAutoTableLayoutExtension {
  // 是否显示右侧的字段排序, 默认显示
  // 当表格项：有合并行/列，多级表头时，目前业务场景不覆盖此条件下的排序or隐藏显示。
  // 主要因为提效组件满足基本需求为主，这类个性化的处理相对比较复杂、灵活性低，如果内置此功能将会影响性能和增加使用者的难度
  readonly isEnableFieldSort?: boolean;
  readonly isEnableTableFontSize?: boolean; // 是否开启表格大小设置

  readonly renderTopbarRight?: React.ReactNode | null; // 顶部右侧插槽
  readonly renderTableTopSpace?: React.ReactNode | null; // 表格与搜索条件之间的插槽

  // 扩展搜索条件 (如果配置有场景聚合的话，仅插入到过滤条件的前缀)
  readonly renderFilterComponent?: <T>(
    filterValues: IString<IValue>,
    configFields: ReadonlyArray<IConfigField<T>>
  ) => React.ReactNode | null;

  // 扩展搜索条件 (前缀)
  readonly renderFilterPrefix?: <T>(
    filterValues: IString<IValue>,
    configFields: ReadonlyArray<IConfigField<T>>
  ) => React.ReactNode | null;

  readonly showFilter?: boolean; // 是否显示搜索条件, 默认显示
  readonly showTopbar?: boolean; // 是否显示Topbar(搜索条件/字段配置), 默认显示
  readonly showTable?: boolean; // 是否显示表格部分, 默认显示

  // 是否开启刷新事件
  readonly onReload?: () => Promise<boolean>;

  // 是否配置渲染场景
  readonly renderScene?: IRenderSceneExtension;
  // 是否开启点击弹窗外的区域就可以关闭弹窗
  readonly closeSettingByClickExternal?: boolean;
}
